import { render, staticRenderFns } from "./SearchBrands.vue?vue&type=template&id=5a5cce5c&scoped=true&"
import script from "./SearchBrands.vue?vue&type=script&lang=js&"
export * from "./SearchBrands.vue?vue&type=script&lang=js&"
import style0 from "./SearchBrands.vue?vue&type=style&index=0&id=5a5cce5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cce5c",
  null
  
)

export default component.exports